export default {
  assets: {
    assetModel: "asset Model",
    assetTypes: "asset Type",
    asset: "Asset",
    assetName: "Asset Name",
    assetSerialNumber: "Asset Serial Number",
    assetsPlural: "Assets",
    serialNo: "Serial No.",
    assetLevel: "Asset Level",
    assetType: "Asset Type",
    tags: "Tags",
    modelDescription: "Model Description",
    assetDescription: "Asset Description",
    attribute: "Attribute",
    attributes: "Attributes",
  },
  assetTypes: {
    name: "Asset Type",
    plural: "Asset Types",
    columns: {
      id: "ID",
      assetTypeName: "Asset Type Name",
      description: "Description",
      createdBy: "Created By",
      createdAt: "Created at",
      modifiedAt: "Modified at",
      modifiedBy: "Modified By",
      model: "Model",
      models: "Models",
    },
    updateAssetType: {
      error: {
        title: "Asset Type cannot be {action}",
        message: "This Asset Type is a System Asset Type and cannot be {action}.",
      },
    },
  },
  assetModel: {
    name: "Asset Model",
    plural: "Asset Models",
    nameWithCount: "Model ({count})",
    columns: {
      id: "ID",
      assetModelName: "Asset Model Name",
      description: "Description",
      createdBy: "Created By",
      createdAt: "Created At",
      modifiedAt: "Modified At",
      modifiedBy: "Modified By",
    },
  },
  assetAttributeSets: {
    name: "Asset Attribute Set",
    plural: "Asset Attribute Sets",
    columns: {
      id: "ID",
      assetAttributeSetName: "Asset Attribute Set Name",
      description: "Description",
      createdBy: "Created By",
      createdAt: "Created at",
      modifiedAt: "Modified at",
      modifiedBy: "Modified By",
      lastChangedAt: "Last Changed At",
    },
  },
  devices: {
    name: "Device",
    plural: "Devices",
    deviceName: "Device Name",
    deviceModel: "Device Model",
    deviceType: "Device Type",
    deviceTypeDetails: "Device Type Details",
    device: "Device",
    devicesPlural: "Devices",
    serialNo: "Software Serial No.",
    hardwareSerialNo: "Hardware Serial No.",
    deploymentGroup: "Deployment Group",
    noDeploymentGroup: "No Deployment Group",
    tags: "Tags",
    status: "Status",
    healthStatus: "Health Status",
    lastStoreActivity: "Last Store Activity",
    lastMessagingActivity: "Last Messaging Activity",
  },
  deviceModel: {
    name: "Device Model",
    plural: "Device Models",
    columns: {
      id: "ID",
      modelName: "Model Name",
      description: "Description",
      createdBy: "Created By",
      createdAt: "Created At",
      modifiedAt: "Modified At",
      modifiedBy: "Modified By",
    },
  },
  deploymentGroups: {
    name: "Deployment Group",
    plural: "Deployment Groups",
    columns: {
      name: "Name",
      description: "Description",
      deviceModelRevision: "Device Model Revision",
      autoUpdateMode: "Auto Update Mode",
      isDeltaUpdateOnly: "Delta Update Only",
      ownerUserId: "Owner User ID",
      deviceCount: "Device Count",
      updatedDeviceCount: "Updated Device Count",
      totalPendingActionCount: "Total Pending Actions",
      createdAt: "Created At",
      createdBy: "Created By",
      modifiedAt: "Modified At",
      modifiedBy: "Modified By",
    },
  },
  edgeDevices: {
    name: "Edge Device",
    plural: "Edge Devices",
    columns: {
      deviceName: "Device Name",
      deviceSerial: "Device Serial Number",
      deviceModel: "Device Model",
      deviceArchitecture: "Device Architecture",
      deviceGatewayPublicKey: "Device Gateway Public Key",
      deviceLastActivity: "Last Activity",
      deviceModelRevision: "Device Model Revision",
      manufacturer: "Manufacturer",
      createdAt: "Created At",
      createdBy: "Created By",
      modifiedAt: "Modified At",
      modifiedBy: "Modified By",
    },
  },
  user: {
    name: "User",
    plural: "Users",
    columns: {
      id: "ID",
      userName: "User",
      userInformation: "User Information",
      contact: "Contact",
      firstName: "First Name",
      lastName: "Last Name",
      authenticationProvider: "Authentication Provider",
      email: "Email",
      emailAdress: "Email address",
      tenant: "Tenant",
      role: "Role",
      roles: "Roles",
      registered: "Registered",
      registrationDate: "Registration Date",
      language: "Language",
      myProfile: "My Profile",
      userDescription: "User Description",
      lastLogin: "Last Login",
      createdAt: "Created at",
      modifiedAt: "Modified at",
      isDeleted: "is deleted",
      displayName: "Display Name",
    },
  },
  tenant: {
    name: "Tenant",
    plural: "Tenants",
    columns: {
      id: "ID",
      tenantIdentifier: "Tenant ID",
      tenantName: "Tenant Name",
      isDeleted: "is deleted",
      createdAt: "Created at",
      modifiedAt: "Modified at",
      tenantRole: "Tenant Role",
      tenantType: "Tenant Type",
    },
  },
  role: {
    name: "Role",
    plural: "Roles",
    columns: {
      id: "ID",
      name: "Name",
      description: "Description",
      isDefaultRole: "is default role",
      createdAt: "Created at",
      modifiedAt: "Modified at",
      isDeleted: "is deleted",
    },
  },
  dataRangeSelector: {
    selectDateRange: "Zeitraum Auswählen",
    start: "Start",
    end: "Ende",
  },
  apps: {
    name: "App",
    plural: "Apps",
    columns: {
      appName: "App Name",
      appDescription: "Description",
      appType: "Type",
      appCategory: "Category",
      appDeviceArchitecture: "Architecture",
      installedDevicesCount: "Installed Devices",
      version: "Version",
      rating: "Rating",
      installedDeviceCount: "Usage (Installed on devices)",
      createdAt: "Created At",
      createdBy: "Created By",
      modifiedAt: "Modified At",
      modifiedBy: "Modified By",
      lastChangedAt: "Last Changed At",
      size: "Size [MB]",
    },
  },
  software: {
    name: "App",
    plural: "Apps",
    columns: {
      name: "Name",
      softwareName: "Software Name",
      description: "Description",
      architecture: "Architecture",
      softwareDeviceArchitecture: "Architecture",
      version: "Version",
      rating: "Rating",
      installedDeviceCount: "Usage (Installed on devices)",
      createdAt: "Created At",
      createdBy: "Created By",
      lastChangedAt: "Last Changed At",
      modifiedAt: "Modified At",
      modifiedBy: "Modified By",
      summary: "Summary",
    },
    firmware: {
      noFirmwareAssigned: "No Firmware Assigned",
    },
    osImage: {
      noOSImageAssigned: "No OS Images Assigned",
    },
  },
  softwareRevision: {
    name: "App Revision",
    plural: "App Revisions",
    columns: {
      description: "Description",
      version: "Version",
      buildDateTime: "Build Date & Time",
      createdAt: "Created At",
      createdBy: "Created By",
      lastChangedAt: "Last Changed At",
      modifiedAt: "Modified At",
      modifiedBy: "Modified By",
      revision: "Revision",
      softwareObjectSize: "Size [MB]",
    },
  },
};
